
import {WebRTCAdaptor} from "./webrtc_adaptor.js"

export default WebRTCAdaptor;
